import { ScrollAreaProps } from '@radix-ui/react-scroll-area';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { ScrollArea } from 'src/core/ui';
import { ScrollAreaRefActions } from 'src/core/ui/ScrollArea/ScrollArea';

import * as styles from './ScrollableToolbar.css';

export function ScrollableToolbar({
  children,
  scrollAreaRefActions,
  showScrollEdges = true,
  showScrollButton = true,
  scrollAreaClassName,
  ...props
}: PropsWithChildren<ScrollAreaProps> &
  ScrollAreaRefActions & {
    showScrollEdges?: boolean;
    showScrollbar?: boolean;
    scrollAreaClassName?: string;
  }) {
  return (
    <ScrollArea
      showScrollEdges={showScrollEdges}
      showScrollButton={showScrollButton}
      {...props}
      scrollAreaRefActions={scrollAreaRefActions}
    >
      <div className={clsx(styles.root, scrollAreaClassName)}>{children}</div>
    </ScrollArea>
  );
}
